export default [
    {
        path: 'company',
        name: 'company',
        component: () => import('./views/CompanyView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Company'
        },
    },
    {
        path: 'tablas-generales',
        name: 'tablas-generales',
        component: () => import('./views/TablasGeneralesView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Tablas Generales',
            // Solo COMPANY: cubre también todas sus "vistas" internas
            // (Certificados, Servicios, Categoría, Ámbito, etc.) porque son
            // pestañas ?tab= de esta misma ruta, no rutas aparte.
            roles: ['COMPANY']
        },
    }
]